module.exports = __webpack_public_path__ + "img/noel_hat.f53ae696.png";